module.exports = __webpack_public_path__ + "img/16.db3ecf1b.jpg";